import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography } from "antd";
import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";
import Linechart from "./chartJs/Linechart";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard7_5 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [dataBar7_5_3, _dataBar7_5_3] = useState();
  const [dataBar7_5_4, _dataBar7_5_4] = useState();
  const [dataBar7_5_12, _dataBar7_5_12] = useState();
  const [dataBar7_5_13, _dataBar7_5_13] = useState();
  const [dataBar7_5_16, _dataBar7_5_16] = useState();
  const [dataBar7_5_17, _dataBar7_5_17] = useState();
  const [dataBar7_5_18, _dataBar7_5_18] = useState();
  const [dataBar7_5_19, _dataBar7_5_19] = useState();

  const [dataLine7_5_9, _dataLine7_5_9] = useState();
  const [dataLine7_5_10, _dataLine7_5_10] = useState();
  const [dataLine7_5_11, _dataLine7_5_11] = useState();

  useEffect(() => {
    Find_barData("bar7_5_3");
    Find_barData("bar7_5_4");
    Find_barData("bar7_5_12");
    Find_barData("bar7_5_13");
    Find_barData("bar7_5_16");
    Find_barData("bar7_5_17");
    Find_barData("bar7_5_18");
    Find_barData("bar7_5_19");

    Find_lineData("line7_5_9");
    Find_lineData("line7_5_10");
    Find_lineData("line7_5_11");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db7_5", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = i.name + 543;

            if (order == "bar7_5_3") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_4") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_12") {
              Tb1.push({
                name: zyear,
                degree_level: i.degree_level,
                total_student: i.total_student
              });
            } else if (order == "bar7_5_13") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_16") {
              Tb1.push({
                name: zyear,
                type_cmu: i.type_cmu,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_17") {
              Tb1.push({
                name: zyear,
                type_cmu: i.type_cmu,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_18") {
              Tb1.push({
                name: zyear,
                type_cmu: i.type_cmu,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_19") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar7_5_3") {
          _dataBar7_5_3(Tb1);
        } else if (order == "bar7_5_4") {
          _dataBar7_5_4(Tb1);
        } else if (order == "bar7_5_12") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const degree = r.degree_level;
            const year = r.name;

            if (!acc[degree]) acc[degree] = { degree };

            acc[degree][year] = r.total_student;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_12({
            data: chartData,
            years
          });

          return; // ⭐ สำคัญ ไม่ให้ set ซ้ำ
        } else if (order == "bar7_5_13") {
          _dataBar7_5_13(Tb1);
        } else if (order == "bar7_5_16") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const type_cmu = r.type_cmu;
            const year = r.name;

            if (!acc[type_cmu]) acc[type_cmu] = { type_cmu };

            acc[type_cmu][year] = r.zcount;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_16({
            data: chartData,
            years
          });

          return;
        } else if (order == "bar7_5_17") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const type_cmu = r.type_cmu;
            const year = r.name;

            if (!acc[type_cmu]) acc[type_cmu] = { type_cmu };

            acc[type_cmu][year] = r.zcount;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_17({
            data: chartData,
            years
          });

          return;
        } else if (order == "bar7_5_18") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const type_cmu = r.type_cmu;
            const year = r.name;

            if (!acc[type_cmu]) acc[type_cmu] = { type_cmu };

            acc[type_cmu][year] = r.zcount;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_18({
            data: chartData,
            years
          });

          return;
        } else if (order == "bar7_5_19") {
          _dataBar7_5_19(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_lineData = order => {
    axios
      .post(xURL + "db_linechart_db7_5", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = parseInt(i.name) + 543;

            if (order == "line7_5_9") {
              Tb1.push({
                name: zyear,
                total1: i.total1,
                total2: i.total2
              });
            } else if (order == "line7_5_10") {
              Tb1.push({
                name: zyear,
                total1: i.total1,
                total2: i.total2
              });
            } else if (order == "line7_5_11") {
              Tb1.push({
                name: zyear,
                total1: i.total1,
                total2: i.total2,
                total3: i.total3
              });
            }
          });
        }

        if (order == "line7_5_9") {
          _dataLine7_5_9(Tb1);
        } else if (order == "line7_5_10") {
          _dataLine7_5_10(Tb1);
        } else if (order == "line7_5_11") {
          _dataLine7_5_11(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านการเงิน ตลาด และกลยุทธ์
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="จำนวนเงินทุนวิจัยจากแหล่งทุนต่างประเทศ (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_3} order={"bar7_5_3"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="จำนวนเงินทุนวิจัยจากแหล่งทุนในประเทศ (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_4} order={"bar7_5_4"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีงบประมาณ
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="จำนวนโครงการวิจัยแยกตามแหล่งทุน (โครงการ)"
          >
            <Linechart dataLine={dataLine7_5_9} order={"line7_5_9"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="จำนวนโครงการวิจัยแยกตามประเภททุน (โครงการ)"
          >
            <Linechart dataLine={dataLine7_5_10} order={"line7_5_10"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="จำนวนโครงการวิจัยแยกตามทิศทาง (โครงการ)"
          >
            <Linechart dataLine={dataLine7_5_11} order={"line7_5_11"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 4 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="จำนวนนักศึกษาแรกเข้าในแต่ละหลักสูตร (คน)"
          >
            <Barchart dataBar={dataBar7_5_12} order={"bar7_5_12"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="ร้อยละของนักศึกษาแรกเข้าที่เป็นคนต่างชาติ"
          >
            <Barchart dataBar={dataBar7_5_13} order={"bar7_5_13"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 5 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="จำนวนเงินทุนวิจัยแยกตามทิศทาง (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_16} order={"bar7_5_16"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="จำนวนผลงานตีพิมพ์ของ BEEN research (เรื่อง)"
          >
            <Barchart dataBar={dataBar7_5_17} order={"bar7_5_17"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 6 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title=" จำนวนผลงานตีพิมพ์ของ BEEN research ใน Q1"
          >
            <Barchart dataBar={dataBar7_5_18} order={"bar7_5_18"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title=" จำนวนผลงานอนุสิทธิบัตร/สิทธิบัตร"
          >
            <Barchart dataBar={dataBar7_5_19} order={"bar7_5_19"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_5;
